module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-top.2cc12823.svg";